import type { ReactNode } from 'react';
import { Redirect, Route, Switch } from 'wouter';
import { FullPageLoading } from './components/Spinner';
import { AddCardPage } from './pages/AddCardPage';
import { AdminPage } from './pages/AdminPage';
import { ForgotPasswordPage, LoginPage, RegisterPage, ResetPasswordPage } from './pages/AuthPages';
import { BoardPage } from './pages/BoardPage';
import { PageShell, ProfilePage } from './pages/ProfilePage';
import { useSession } from './state/session';

function RequireUser({ children, admin = false }: { children: ReactNode; admin?: boolean }) {
  const { status, user } = useSession();
  if (status === 'loading') return <FullPageLoading />;
  if (!user) return <Redirect to="/login" replace />;
  if (admin && !user.isAdmin) {
    return (
      <PageShell title="Acesso restrito">
        <p>Esta área é exclusiva para administradores.</p>
      </PageShell>
    );
  }
  return <>{children}</>;
}

function GuestOnly({ children }: { children: ReactNode }) {
  const { status, user } = useSession();
  if (status === 'loading') return <FullPageLoading />;
  if (user) return <Redirect to="/" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <Switch>
      <Route path="/login">
        <GuestOnly>
          <LoginPage />
        </GuestOnly>
      </Route>
      <Route path="/cadastro">
        <GuestOnly>
          <RegisterPage />
        </GuestOnly>
      </Route>
      <Route path="/esqueci-senha">
        <GuestOnly>
          <ForgotPasswordPage />
        </GuestOnly>
      </Route>
      {/* Open whether or not someone is signed in: the link comes from an e-mail. */}
      <Route path="/redefinir-senha">
        <ResetPasswordPage />
      </Route>
      <Route path="/perfil">
        <RequireUser>
          <ProfilePage />
        </RequireUser>
      </Route>
      <Route path="/adicionar-cartao">
        <RequireUser>
          <AddCardPage />
        </RequireUser>
      </Route>
      <Route path="/admin">
        <RequireUser admin>
          <AdminPage />
        </RequireUser>
      </Route>
      <Route path="/">
        <RequireUser>
          <BoardPage />
        </RequireUser>
      </Route>
      <Route>
        <PageShell title="Página não encontrada">
          <p>O endereço acessado não existe.</p>
        </PageShell>
      </Route>
    </Switch>
  );
}
